import Axios from 'axios';

const API_URL = '/api';

/**
   * Converts input parameters into query string
   * @param {object} params
   */
const convertToQueryParams = (params) => {
  let paramString = '';

  if (typeof params !== 'undefined' && params !== null) {
    // Initial ? icon
    paramString = '?';

    // Maps trough objects
    paramString += Object.keys(params)
      .map((param, index) => {
        let returnParam = '';

        // After first param, we put & icon
        if (index > 0) {
          returnParam += '&';
        }

        // Handle pagination 'page' value for 0
        if (
          (param === 'page' && params[param] === 0) ||
            (param === 'page' && params[param] === '0')
        ) { params[param] = 1; }

        // Joining parameters
        returnParam += `${param}=${String(params[param])}`;

        return returnParam;
      })
      .join('');
  }

  return paramString;
};

const checkStatus = (response) => {
  // raises an error in case response status is not a success
  if (response.status >= 200 && response.status < 400) {
    return response.data;
  }
  const promise = new Promise(((resolve, reject) => {
    reject(response);
  }));

  return promise;
};

const formatSuccess = response => checkStatus(response);

const formatErrors = errors => checkStatus(errors);


class ApiCore {
  static get(url, params, pagination = false) {
    const queryString = convertToQueryParams(params);

    return Axios({
      url: API_URL + url + queryString,
    })
      .then((response) => {
        if (pagination !== false) {
          response.data.pagination = {
            // count: parseInt(response.headers['x-wp-total']),
            count: response.data.paging.total,
            // pages: parseInt(response.headers['x-wp-totalpages']),
            pages: response.data.paging.totalPages,
            currentPage: pagination.page === 0 ? 1 : pagination.page,
          };
        }

        return response.data;
      })
      .catch(error => Promise.reject(error));
  }

  static post(url, params, urlParams = []) {
    let paramString = convertToQueryParams(urlParams);

    if (paramString === '?') {
      paramString = '';
    }

    return Axios
      .post(API_URL + url + paramString, params)
      .then(response => formatSuccess(response))
      .catch(errors => formatErrors(errors));
  }
}

export default ApiCore;
